module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightmodsnow@3-3a27e817481958f9d4b99f40d6faff46.png";